'use-strict'

import { App } from "../utilities/App";
import { isset } from "../utilities/utilities";
import { showNavbarCart } from "./nav";

function productsGridInit() {

	App.isActiveProductsGridSlider = false;

	onToggleProductsGridSlider();
	
}
function productsGridActions() {

	/* Colors */
	$('[js-product-colors-button]').on('click', function() {
		onClickProductsGridColorsButton( $(this) );
	});

	$('[js-product-colors-element]').on('click', function() {
		onClickProductsGridColorsElement( $(this) );
	});
	
	/* Counter */
	$(document).on('change', '.products-grid .qnt-counter__input', function() {
		onChangeProductsGridQuantityInput( $(this) );
	});
	$('.products-grid .qnt-counter__input').each(function() {
		onChangeProductsGridQuantityInput( $(this) );
	});

	/* Button */
	$(document).on('click', '.products-grid__button button', function() {
		onClickProductsGridAddButton( $(this) );
	});

	$('.products-grid__button button').each(function() {

		if ( $(this).data('id') === '' || !isset($(this).data('id')) ) $(this).attr('disabled', true);
		
	});

	$(document).on('click', '.products-grid__button--mask', function() {
		onClickProductsGridMask( $(this) );
	});
	
}

function onClickProductsGridMask(target) {
	
	const parent = target.parents('.products-grid__actions');
	const alert = parent.find('.color-alert');
	
	if(! (alert.is(':visible')) ) alert.fadeIn();
	setTimeout(function() {
		alert.fadeOut();
	}, 2000);
	
}

function onClickProductsGridColorsButton( target ) {
	
	target.parents('[js-product-colors]').toggleClass('products-grid__colors--expanded');
	
}

function changeImage(target, elem) {
	const colorName = target[0].getAttribute('title');
	const parentBlock = elem[0];

	if(! parentBlock.querySelector(`#products-grid__element__colors div[title="${colorName}"]`)) return;
	const imageBlock = parentBlock.querySelector('.image-block');
	const pathBlock = parentBlock.querySelector(`#products-grid__element__colors div[title="${colorName}"]`);
	const path = pathBlock.getAttribute('path').replace('${extension}', '');
	const sources = parentBlock.querySelectorAll('picture source, picture img');
	imageBlock.querySelector('img').classList.add('animate');
	imageBlock.querySelector('img').addEventListener('transitionend', endAnimation, false);
	function endAnimation() {
		changeSourceHome(sources, path);
		if( imageBlock.classList.contains('slider') ) imageBlock.classList.remove('slider');
		if(imageBlock.querySelector('img').complete) {
			imageLoaded(imageBlock.querySelector('img'));
		} else {
			imageBlock.querySelector('img').addEventListener('load', imageLoaded(imageBlock.querySelector('img')));
		}
	}
	function imageLoaded(rootBlock) {
		rootBlock.classList.remove('animate');
	}
}

function newString(elem, attribute, new_path) {
	let path = elem.getAttribute(attribute);
	let first = path.substring(0, path.search('products/'));
	const extensions = ['.avif', '.webp', '.jpg'];
	let extensionIndex = null;
	let extension = '.png';
	extensions.forEach(ext => {
		if(path.indexOf(ext) > 0) {
			extensionIndex = path.indexOf(ext);
			extension = path.substring(extensionIndex, path.length);
		}
	});
	return first + new_path + extension;
}

function changeSourceHome(sources, path) {
	sources.forEach(element => {
		if(element.getAttribute('srcset')) {
			const newPath = newString(element, 'srcset', path);
			element.setAttribute('srcset', newPath);

		}
		if(element.getAttribute('src')) {
			const newPath = newString(element, 'src', path);
			element.setAttribute('src', newPath);
		}
	});
}

function onClickProductsGridColorsElement( target ) {
	if ( target.hasClass('products-grid__color--unavailable') ) return;
	if ( target.find('.variant-color').hasClass('color--active') ) return;
	const parent = target.parents('.products-grid__element');
	changeImage(target ,parent);
	const html = target.html();
	const parentBtn = target.parents('[js-product-colors]').find('[js-product-colors-button]');
	const addToCartButton = target.parents('.products-grid__actions').find('.products-grid__button button');
	const mask = target.parents('.products-grid__actions').find('.products-grid__button--mask');
	const colors = target.parents('ul').find('li .variant-color');
	const activeColor = target.find('.variant-color')[0];
	for ( let i = 0; i < colors.length; i++ ) {
		colors[i].classList.remove('color--active');
		if(colors[i] == activeColor) {
			colors[i].classList.add('color--active');
		}
	}

	let colorText = target.parents('.products-grid__colors').find('.change_color');
	let colorName = target.parents('[js-product-colors-element]').prevObject.attr('title');

	colorText.text(colorName);

	parentBtn.find('[js-product-colors-label]').fadeOut(0);
	parentBtn.find('[js-product-colors-value]').html(html).fadeIn(0);
	onClickProductsGridColorsButton(parentBtn);

	if ( addToCartButton.data('availability') )
		mask.remove();
		addToCartButton.data('id', target.data('id')).removeAttr('disabled');
	
}
function onChangeProductsGridQuantityInput( target ) {

	const addToCartButton = target.parents('.products-grid__actions').find('.products-grid__button button');
	const priceContainer  = target.parents('.products-grid__actions').find('.products-grid__price');

	addToCartButton.data('quantity', target.val());

	let id = addToCartButton.data('id') || $( target.parents('.products-grid__actions').find('[js-product-colors-element]')[0] ).data('id');
	let quantity = addToCartButton.data('quantity');

	let price = App.getProductPrice(id, quantity);

	priceContainer.find('.old-price').text(App.getCurrencyFormat(price.oldPrice));
	priceContainer.find('.new-price').text(App.getCurrencyFormat(price.newPrice));

	if ( price.oldPrice > price.newPrice ) priceContainer.find('.old-price').fadeIn(0);
	else priceContainer.find('.old-price').fadeOut(0);
	
}
function onClickProductsGridAddButton( target ) {
	
	const id = target.data('id');
	const quantity = target.data('quantity');
	
	App.productPlus(id, quantity, showNavbarCart);
	
}

function onToggleProductsGridSlider() {

	if ( $(window).width() < 350 ) {

		if ( !App.isActiveProductsGridSlider ) {
		
			$('.products-grid__wrapper')
				.on('init', function(_event, slick) {

					let all = slick.$slides;
					let current = $(all[slick.currentSlide]);

					current.addClass('products-grid__element--active');

				})
				.on('beforeChange', function(_event, slick, currentSlide, nextSlide) {

					let all = slick.$slides;
					let current = $(all[currentSlide]);
					let next    = $(all[nextSlide]);
					
					current.removeClass('products-grid__element--active');
					next.addClass('products-grid__element--active');

				})
				.on('destroy', function(event, slick) {

					let all = slick.$slides;
					let current = $(all[slick.currentSlide]);

					current.removeClass('products-grid__element--active');
					
				})
				.slick({
					speed: 500,
					swipeToSlide: true,
					centerMode: true,
					centerPadding: '0px',
					variableWidth: true,
					prevArrow: $('.products-grid__nav-element--left'),
					nextArrow: $('.products-grid__nav-element--right'),
				});
			
			App.isActiveProductsGridSlider = true;
			
		}
		
	} else {
		
		if ( App.isActiveProductsGridSlider ) {
			
			$('.products-grid__wrapper').slick('unslick')
			App.isActiveProductsGridSlider = false;
			
		}
		
	}
	
}

export {
	productsGridInit,
	productsGridActions,
	onToggleProductsGridSlider,
};